import gql from 'graphql-tag';

export default gql`
  query getModeloNota($id: String!) {
    getModeloNota(idModeloNota: $id) {
      _id
      titulo
      descripcion
      htmlModelo
      talonarios {
        talonario {
          _id
          nombre
          cantidad
        }
        organismo {
          _id
          nombre
        }
      }
      organismos {
        _id
        nombre
      }
      clasificadoresEstadisticos {
        _id
        nombre
        descripcion
      }
    }
  }
`;
